import { useQuery } from '@apollo/client';

import { GET_ADVERTISEMENTS } from 'schemas';

import {
  IUseGetAdvertisementsParams,
  IUseGetAdvertisementsReturn,
} from './interfaces';

export const useGetAdvertisements = (
  params?: IUseGetAdvertisementsParams
): IUseGetAdvertisementsReturn => {
  const { data, loading } = useQuery(GET_ADVERTISEMENTS, {
    variables: params,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    skip: params?.skip,
  });

  return {
    advertisements: data?.getAdvertisements?.advertisements?.data ?? [],
    paginator: data?.getAdvertisements?.advertisements?.paginatorInfo,
    loading,
  };
};
